const DismissibleAlert = ({ children, onDismiss, variant = "error" }) => {
  const styles =
    variant === "success"
      ? "bg-green-100 text-green-800"
      : "bg-red-100 text-red-800";

  return (
    <div
      role={variant === "success" ? "status" : "alert"}
      className={`mb-4 flex items-start justify-between gap-4 rounded p-3 ${styles}`}
    >
      <p>{children}</p>
      <button
        type="button"
        aria-label="Dismiss message"
        onClick={onDismiss}
        className="-mr-1 -mt-1 shrink-0 rounded px-2 py-1 text-lg leading-none hover:bg-black/10"
      >
        ×
      </button>
    </div>
  );
};

export default DismissibleAlert;
